export enum RoutesEnum {
  NotFound = 'not-found',
  Home = '/',
  AgileBasics = 'agile-basics',
  Dynamic = '**',
}
